<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <div class="weui-cells">
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label for class="weui-label">币种</label>
          </div>
          <div class="weui-cell__bd">
            <span v-if="form.id">{{form.cr_name}}</span>
            <input v-else class="weui-input" type="text" v-model="form.cr_name" placeholder="请输入币种" />
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label for class="weui-label">汇率</label>
          </div>
          <div class="weui-cell__bd">
            <input class="weui-input" type="number" v-model="form.cr_rate" placeholder="请输入汇率" />
          </div>
        </div>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_primary" @click="save">保存</a>
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
      >取消</a>
    </div>
  </div>
</template>

<script>
import form from "@/mixins/form.js";

export default {
  mixins: [form],
  data() {
    return {
      baseUrl: "/api/document/currency",
      form: {
        cr_rate: 1
      }
    };
  },
  methods: {
    save() {
      var me = this,
        main = me.form;
      if (!main.cr_name) {
        me.$weui.topTips("请填写币种", 2000);
      } else if (!main.cr_rate) {
        me.$weui.topTips("请填写汇率", 2000);
      } else {
        me.f_save();
      }
    }
  }
};
</script>